module.exports = __webpack_public_path__ + "static/media/neut.33704f7a.png";